class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('#predictive-search');

    this.input.addEventListener(
      'input',
      this.debounce(() => {
        this.onSearch();
      }, 250)
    );

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.close();
      }
    });
  }

  onSearch() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.fetchResults(searchTerm);
  }

  fetchResults(searchTerm) {
const url =
  `/search/suggest?q=${encodeURIComponent(searchTerm)}` +
  `&resources[type]=product,collection,article,page,query` +
  `&resources[limit_scope]=each` +
  `&resources[limit]=6` +
  `&resources[options][unavailable_products]=hide` +
  `&section_id=predictive-search`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);

        return response.text();
      })
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search");

        if (!html) {
          this.close();
          return;
        }

        this.results.innerHTML = html.innerHTML;

        this.bindTabs();

        this.open();
      })
      .catch((error) => {
        console.error(error);
        this.close();
      });
  }

  bindTabs() {
    const tabs = this.results.querySelectorAll(".predictive-search__tab");
    const panels = this.results.querySelectorAll(".predictive-search__panel");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {

        tabs.forEach((t) => t.classList.remove("active"));
        panels.forEach((p) => p.classList.remove("active"));

        tab.classList.add("active");

        const target = this.results.querySelector(
          "#" + tab.dataset.tab
        );

        if (target) {
          target.classList.add("active");
        }
      });
    });
  }

  open() {
    this.results.style.display = "block";
  }

  close() {
    this.results.style.display = "none";
  }

  debounce(fn, wait) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        fn.apply(this, args);
      }, wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);